import classNames from 'classnames';

export type AgeVerificationStatus =
  | 'not_started'
  | 'in_review'
  | 'unsuccessful'
  | 'unsuccessful_retry'
  | 'successful'
  | 'not_needed'
  | 'failure'
  | 'error';

export const STATUS_START = 'not_started';
export const STATUS_REVIEWING = 'in_review';
export const STATUS_UNSUCCESSFUL = 'unsuccessful_retry';
export const STATUS_FAILURE = 'failure';
export const STATUS_SUCCESSFUL = 'successful';

// not from backend
export const STATUS_ERROR = 'error';

export type LayoutType = 'full' | 'compact';

export const LAYOUT_FULL = 'full';
export const LAYOUT_COMPACT = 'compact';

// Error reason mapping: https://gotinder.atlassian.net/l/cp/ZecJdEMQ
export const DENIED_UNSUPPORTED_ID_TYPE = 1;
export const DENIED_UNSUPPORTED_ID_COUNTRY = 2;
export const ERROR_NOT_READABLE_ID = 3;
export const NO_ID_UPLOADED = 4;

export const ERROR_MESSAGE_MAPPING = {
  [DENIED_UNSUPPORTED_ID_TYPE]: {
    title: 'AgeVerification.unsuccessfulUnsupportedIdTitle',
    subtitle: 'AgeVerification.unsuccessfulUnsupportedId',
  },
  [DENIED_UNSUPPORTED_ID_COUNTRY]: {
    title: 'AgeVerification.unsuccessfulAnotherIdTitle',
    subtitle: 'AgeVerification.unsuccessfulAnotherId',
  },
  [ERROR_NOT_READABLE_ID]: {
    title: 'AgeVerification.unsuccessfulSubmitTitle',
    subtitle: 'AgeVerification.unsuccessfulSubmit',
  },
  [NO_ID_UPLOADED]: {
    title: 'AgeVerification.noId',
  },
};

export const reviewDocumentChecklistItemClassName = classNames(
  'Ai(c) D(f)',
  // Item number pseudo element
  'Bdrs(16px)::b Bgc($c-ds-background-button-primary-small)::b C($c-ds-text-primary-inverse)::b',
  'Cnt($content)::b Mend(12px)::b',
  'CenterAlign::b',
  'Typs(caption-1-strong)::b',
  'Sq(16px)::b'
);

export const takePhotoGrantPermissionCtaClassName = classNames(
  'Bdc($c-ds-accent-primary) Bdrs(12px) Bd',
  'Ai(c) D(f) Fxd(c) Jc(c)',
  'C($c-ds-accent-primary) Typs(button-1)',
  'My(10px) Py(60px) W(100%)'
);

export const REMOTE_VIEW_COMPLETION_DEEP_LINK = 'tinder://age-verification/success';

export const USER_MEDIA_CONFIG = {
  constraints: {
    video: true,
  },
  requireConsent: false,
  returnMediaStream: true,
};

// Prefer device back camera, when available
export const USER_MEDIA_CONFIG_FACING_MODE = {
  ...USER_MEDIA_CONFIG,
  constraints: {
    video: {
      facingMode: 'environment',
    },
  },
};
